import mixpanel, { type Config } from "mixpanel-browser";

// Kept out of autocapture event properties: these attributes can carry PHI (e.g. a patient name in
// `title`). Session replay is not covered — it still records attributes, so keep PHI out of them.
const AUTOCAPTURE_BLOCKED_ATTRS = [
  "title",
  "aria-label",
  "aria-describedby",
  "alt",
  "placeholder",
];

let initialized = false;

export function initMixpanel(token: string, config?: Partial<Config>): void {
  if (!token || initialized) return;

  mixpanel.init(token, {
    track_pageview: false,
    persistence: "localStorage",
    batch_requests: false,
    record_mask_all_text: true,
    record_block_selector: "img, video, audio, .rdp-root",
    record_console: false,
    ...config,
    // An object config is merged over Mixpanel's autocapture defaults, so every event type stays on.
    autocapture:
      config?.autocapture === true
        ? { block_attrs: AUTOCAPTURE_BLOCKED_ATTRS }
        : (config?.autocapture ?? false),
  });

  initialized = true;
}

export function identifyUser(
  userId: string,
  userProps?: Record<string, unknown>,
): void {
  if (!initialized) return;

  mixpanel.identify(userId);

  if (userProps && Object.keys(userProps).length > 0) {
    mixpanel.people.set(userProps);
  }
}

export function setSuperProperties(props: Record<string, unknown>): void {
  if (!initialized) return;
  mixpanel.register(props);
}

export function track(event: string, props?: Record<string, unknown>): void {
  if (!initialized) return;
  mixpanel.track(event, props);
}

export function resetAnalytics(): void {
  if (!initialized) return;
  mixpanel.reset();
}
